__turbopack_context__.v({
  "active": "Header-module__bL51Jq__active",
  "content": "Header-module__bL51Jq__content",
  "desktopActions": "Header-module__bL51Jq__desktopActions",
  "header": "Header-module__bL51Jq__header",
  "headerSlot": "Header-module__bL51Jq__headerSlot",
  "link": "Header-module__bL51Jq__link",
  "logo": "Header-module__bL51Jq__logo",
  "nav": "Header-module__bL51Jq__nav",
  "navMobile": "Header-module__bL51Jq__navMobile",
  "slideIn": "Header-module__bL51Jq__slideIn",
});
